/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import useMsalFunctions from '../util/useMsalAuthFunctions';
import { useEffect, FC, useState } from 'react';
import { Loader, LoadingBox } from '../components/Loader';
import { useSearchParams } from 'react-router-dom';
import CELinkNoAccess from './CELinkNoAccess';
import TestIds from '../testIds';

const ACCOUNT_NUMBER_PARAM = 'accountnum';

const CELink: FC = (): JSX.Element => {
  const { handleMsalCELogin } = useMsalFunctions();
  const [searchParams] = useSearchParams();
  const [noAccess, setNoAccess] = useState<boolean>(false);

  useEffect(() => {
    const accountNumber = searchParams.get(ACCOUNT_NUMBER_PARAM);
    if (accountNumber) {
      setNoAccess(false);
      handleMsalCELogin(accountNumber);
    } else {
      setNoAccess(true);
    }
  }, [searchParams]);

  if (noAccess) {
    return <CELinkNoAccess />;
  }

  return (
    <LoadingBox data-testid={TestIds.pages.ceLink}>
      <Loader title='Loading FarmlandsPRO' />
    </LoadingBox>
  );
};

export default CELink;
